import { DashboardApi20240730 } from '@sequencehq/api/dashboard/v20240730'

type BillingScheduleStatus =
  DashboardApi20240730.GetBillingSchedule.BillingScheduleStatus

export const API_DATE_FORMAT = 'yyyy-MM-dd'
export const SCHEDULE_COMPLETED_STATUSES: Array<BillingScheduleStatus> = [
  'COMPLETED',
  'CANCELLED',
  'SUSPENDED'
]

/** Prefetch and render queries need identical parameters to share cached data. */
export const INVOICES_FOR_SCHEDULE_PARAMS = {
  limit: 5,
  sortBy: 'ACCOUNTING_DATE',
  sortOrder: 'DESC'
} as const
